import type { CarrierLogoProps } from './types'
import LogoSvg from '../../assets/carrier-logos/dhl-logo.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const DHLLogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function DHLLogo(props, ref) {
    const logoProps = getLogoProps(props)

    return <Logo {...logoProps} ref={ref} />
  },
)
